import { ReducerItemsState } from 'shared/interface/globalInterface';
import { ResponseProduct } from 'utils/api/types';

export const FETCH_PRODUCTS_PENDING = 'APPLICATION/PRODUCTS/PENDING';
export const FETCH_PRODUCTS_FETCHED = 'APPLICATION/PRODUCTS/FETCHED';
export const FETCH_PRODUCTS_ERROR = 'APPLICATION/PRODUCTS/ERROR';

export type State = {
  products: ReducerItemsState<ResponseProduct>;
};
